import { useEffect, useState } from "react";
import { clienteService } from "../../../../pages/cliente/service/cliente.service";
import { SelectField } from "../../ui";

interface SelectClienteProps {
  value: string;
  onChange: (id: string, name?: string) => void;
  disabled?: boolean;
  required?: boolean;
}

interface ClienteOption {
  id: string;
  corporateName?: string;
  fullName?: string;
  fantasyName?: string;
}

export function SelectCliente({
  value,
  onChange,
  disabled = false,
  required = false,
}: SelectClienteProps) {
  const [clientes, setClientes] = useState<ClienteOption[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await clienteService.selectCliente();
      setClientes(data);
    };
    fetchData();
  }, []);

  return (
    <SelectField
      label="Selecione um Cliente"
      value={value || ""}
      onChange={(e) => {
        const clienteSelecionado = clientes.find(
          (o) => o.id === e.target.value
        );
        const nome =
          clienteSelecionado?.corporateName ||
          clienteSelecionado?.fullName ||
          clienteSelecionado?.fantasyName ||
          "";
        onChange(e.target.value, nome);
      }}
      required={required}
      disabled={disabled}
    >
      <option value="" />
      {clientes.map((cliente) => (
        <option key={cliente.id} value={cliente.id}>
          {cliente.corporateName || cliente.fullName || cliente.fantasyName}
        </option>
      ))}
    </SelectField>
  );
}